export const getNotifications = (state) => state.notifications.notifications;
